import {
    MdAssignment, MdCameraAlt, MdDescription, MdRateReview, MdLightbulbOutline, MdInsights,
    MdMenuBook, MdPictureAsPdf, MdOndemandVideo, MdSlideshow, MdSmartToy,
    MdMailOutline, MdCalendarToday, MdNote, MdCampaign, MdForum, MdSupportAgent, MdSchedule,
    MdHelpOutline, MdStyle, MdTrackChanges, MdChatBubbleOutline, MdOutlineCalculate, MdMicNone, MdFavoriteBorder,
} from 'react-icons/md';

// TODO: credits, usage counts, "new" dates and the on/off state are sample data until the AI module APIs exist.

export const categories = [
    { key: 'tests', title: 'Tests & Practice' },
    { key: 'teaching', title: 'Teaching Content' },
    { key: 'admin', title: 'Admin & Communication' },
    { key: 'students', title: 'For Students' },
]

// `tone` picks the drawn thumbnail palette; `image` replaces it with artwork; `live` tools open a flow on click
export const modules = {
    tests: [
        { id: 'create-test', title: 'Create test with AulasAi', desc: 'Let AI create questions for you', icon: MdAssignment, tone: 'mint', image: '/test-assets/ai_test_card.png', usage: '14.2k', credits: 5, live: 'generateTest' },
        { id: 'extract-pdf', title: 'Extract questions from PDF', desc: 'Scan your physical papers', icon: MdCameraAlt, tone: 'blue', image: '/test-assets/scan_doc_card.png', usage: '9,840', credits: 3, live: 'scanPdf' },
        { id: 'model-papers', title: 'Model papers from past papers', desc: 'Generate new model papers from your existing ones', icon: MdDescription, tone: 'purple', credits: 8, comingSoon: true },
        { id: 'ai-eval', title: 'AI-assisted evaluation', desc: 'Suggested marks and feedback for written answers', icon: MdRateReview, tone: 'peach', credits: 4, comingSoon: true },
        { id: 'solutions', title: 'Test solution explanations', desc: 'Step-by-step solutions for every question in a test', icon: MdLightbulbOutline, tone: 'yellow', credits: 2, comingSoon: true },
        { id: 'insights', title: 'Test result insights', desc: 'Weak chapters, tough questions and students to watch', icon: MdInsights, tone: 'blue', credits: 3, comingSoon: true },
    ],
    teaching: [
        { id: 'lesson-plans', title: 'Lesson plans & notes', desc: 'Create notes or a lesson plan from a chapter', icon: MdMenuBook, tone: 'mint', credits: 4, comingSoon: true },
        { id: 'summarise', title: 'Summarise library material', desc: 'Turn a PDF or video into a summary, flashcards or quiz', icon: MdPictureAsPdf, tone: 'purple', credits: 5, comingSoon: true },
        { id: 'live-summary', title: 'Live class summary', desc: 'Summary and key points from a class recording', icon: MdOndemandVideo, tone: 'pink', credits: 6, comingSoon: true },
        { id: 'lectures', title: 'Create lectures with AI', desc: 'Build lecture slides and talking points for a topic', icon: MdSlideshow, tone: 'blue', credits: 7, comingSoon: true },
        { id: 'virtual-teacher', title: 'Create class with virtual teacher', desc: 'An AI teacher that presents a class for you', icon: MdSmartToy, tone: 'yellow', credits: 10, comingSoon: true },
    ],
    admin: [
        { id: 'parent-comms', title: 'Parent communication drafts', desc: 'AI-drafted messages for progress and events', icon: MdMailOutline, tone: 'mint', credits: 2, comingSoon: true },
        { id: 'timetable', title: 'Smart timetable builder', desc: 'Generate schedules respecting constraints', icon: MdCalendarToday, tone: 'purple', credits: 8, comingSoon: true },
        { id: 'report-cards', title: 'Auto report card remarks', desc: 'Personalised teacher remarks at scale', icon: MdNote, tone: 'blue', credits: 3, comingSoon: true },
        { id: 'announcements', title: 'Announcement generator', desc: 'Draft notices in your institute’s voice', icon: MdCampaign, tone: 'peach', credits: 1, comingSoon: true },
        { id: 'chatbot-students', title: 'AI chatbot for students', desc: 'Answers students’ questions about classes, tests, fees and schedules', icon: MdForum, tone: 'mint', credits: 1, comingSoon: true },
        { id: 'chatbot-others', title: 'AI chatbot for others', desc: 'Answers questions from parents, teachers and staff about your institute', icon: MdSupportAgent, tone: 'pink', credits: 1, comingSoon: true },
        { id: 'create-schedule', title: 'Create schedule with AI', desc: 'Plan classes for a batch from its subjects, teachers and timings', icon: MdSchedule, tone: 'yellow', credits: 4, comingSoon: true },
    ],
    students: [
        { id: 'doubt-solver', title: 'Doubt solver', desc: 'Instant explanations for student questions', icon: MdHelpOutline, tone: 'mint', credits: 1, comingSoon: true },
        { id: 'flashcards', title: 'Auto flashcards', desc: 'Generate study flashcards from any chapter', icon: MdStyle, tone: 'blue', credits: 2, comingSoon: true },
        { id: 'study-plan', title: 'Personal study plan', desc: 'Adaptive weekly plan based on performance', icon: MdTrackChanges, tone: 'purple', credits: 4, comingSoon: true },
        { id: 'tutor', title: '1-on-1 AI tutor', desc: 'Chat-based tutoring for homework help', icon: MdChatBubbleOutline, tone: 'yellow', credits: 3, comingSoon: true },
        { id: 'practice-q', title: 'Practice question generator', desc: 'Endless practice questions by topic', icon: MdOutlineCalculate, tone: 'mint', credits: 2, comingSoon: true },
        { id: 'speaking', title: 'Speaking practice', desc: 'Pronunciation and fluency practice for languages', icon: MdMicNone, tone: 'pink', credits: 5, comingSoon: true },
        { id: 'mood', title: 'Wellness check-ins', desc: 'Private mood & stress reflections for students', icon: MdFavoriteBorder, tone: 'purple', credits: 1, comingSoon: true },
    ],
}

// Switched off by default for this institute; everything else that isn't "coming soon" starts on
export const initiallyDisabled = []

export const credits = {
    used: 48320,
    total: 100000,
    resetsOn: 'Nov 15',
    split: [
        { label: 'Teachers', percent: 38 },
        { label: 'Students', percent: 52 },
        { label: 'Admin', percent: 10 },
    ],
}

export const mostUsed = {
    moduleId: 'create-test',
    generations: 14206,
    change: 12,
    // Relative use over the last 10 periods, oldest first
    trend: [40, 55, 45, 70, 60, 80, 75, 92, 85, 100],
}

export const frequentlyUsed = [
    { moduleId: 'create-test', label: 'Create test', count: '14.2k', bg: '#D7F6E2', fg: '#1E9E52' },
    { moduleId: 'extract-pdf', label: 'Extract from PDF', count: '9,840', bg: '#D9E6FA', fg: '#2A6AD6' },
    { moduleId: 'lesson-plans', label: 'Lesson plans', count: '6,112', bg: '#E6E0F5', fg: '#594099' },
    { moduleId: 'solutions', label: 'Solution explanations', count: '3,784', bg: '#FFEFCB', fg: '#C78C14' },
]

export const newlyAdded = [
    { moduleId: 'speaking', category: 'students', desc: 'Pronunciation and fluency practice for language learners.', date: 'Oct 22' },
    { moduleId: 'practice-q', category: 'students', desc: 'Endless topic-wise questions with difficulty controls.', date: 'Oct 18' },
    { moduleId: 'mood', category: 'students', desc: 'Private mood and stress reflections for students.', date: 'Oct 09' },
]

export const findModule = (id) => Object.values(modules).flat().find(m => m.id === id)
